import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tx from '../Tx';
import Text from '../Text';
import {useState} from 'react';
import {ValidatorForm} from 'react-material-ui-form-validator';
import {api} from '../../maps/data.js';
import SiteTypeSelector from '../SiteTypeSelector';
import TypeChangeApproveDialog from './TypeChangeApproveDialog';

export default function SiteDialog(props) {
    const [approveDialogVisible, setApproveDialogVisible] = useState(false);
    const {open, onClose, newSite, site = {}, clientId, siteTypes, edges} = props;
    const [name, s_name] = useState(site.name || '');
    const [smuIp, s_smuIp] = useState(site.smuIp || '');
    const [siteType, setSiteType] = useState(site.siteType || 'Autonomous');

    const showApproveDialog = () => setApproveDialogVisible(true);
    const hideApproveDialog = () => setApproveDialogVisible(false);

    const save = async () => {
        // Type was changed, password required
        if (siteType !== site.siteType) {
            showApproveDialog();
        } else {
            handleApprove();
        }
    };

    const handleApprove = async () => {
        await api({
            type: newSite ? 'addSite' : 'editSite',
            data: {
                name,
                clientId,
                siteType,
                smuIp,
                _id: site._id
            }
        });
        onClose();
    };

    const handleChangeSiteType = async (e) => {
        const nextType = e.target.value;
        setSiteType(nextType);
    };

    return (
        <>
            <Dialog
                open={!!open}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <ValidatorForm
                    onSubmit={save}
                    onError={errors => console.log(errors)}>

                    <DialogTitle id="alert-dialog-title">
                        {newSite ? <Tx>site.add.title</Tx> : <Tx>site.edit.title</Tx>}
                    </DialogTitle>
                    <DialogContent style={{paddingTop: 5}}>
                        <Text
                            label="g.name"
                            value={name}
                            onChange={s_name}
                            validators={['required']}
                            errorMessages={['this field is required']}/>

                        <div style={{marginTop: 10, marginBottom: 4}}>
                            <SiteTypeSelector
                                options={siteTypes}
                                value={siteType}
                                onChange={handleChangeSiteType}
                            />
                        </div>
                        <div style={{marginTop: 10, marginBottom: 4}}>
                            <Text
                                label="SMU IP"
                                value={smuIp}
                                onChange={s_smuIp}
                            />
                        </div>
                    </DialogContent>

                    <DialogActions>

                        <Button onClick={onClose}><Tx>g.cancel</Tx></Button>
                        <Button autoFocus type="submit">
                            <Tx>g.save</Tx>
                        </Button>

                    </DialogActions>
                </ValidatorForm>
            </Dialog>

            {approveDialogVisible && (
                <TypeChangeApproveDialog
                    visible={approveDialogVisible}
                    onCancel={hideApproveDialog}
                    onApprove={handleApprove}
                />
            )}
        </>
    );
}